import {
  jb_arrow_navigation_css_default
} from "./chunk.TXCOUX7F.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-arrow-navigation/jb-arrow-navigation.ts
var JbArrowNavigation = class extends i {
  clickNext() {
    this.dispatchEvent(
      new CustomEvent(`jb-arrow-navigation:next-clicked`, {
        bubbles: true,
        composed: true
      })
    );
  }
  clickPrev() {
    this.dispatchEvent(
      new CustomEvent(`jb-arrow-navigation:prev-clicked`, {
        bubbles: true,
        composed: true
      })
    );
  }
  render() {
    return b`
      <div class="arrow-navigation">
        <button
          aria-Label="${this.ariaLabels?.prev ?? A}"
          tabindex="${this.prevDisabled ? -1 : 0}"
          .disabled=${this.prevDisabled}
          @click=${this.clickPrev}
          @keyup=${(evt) => {
      if (evt.key === "Enter" || evt.key === " ") {
        this.clickPrev();
      }
    }}
        >
          <jb-icon
            iconName="material:west"
            size="large"
            commonAnimation="move_left"
            ?noHover=${this.prevDisabled}
          ></jb-icon>
        </button>
        <button
          aria-label="${this.ariaLabels?.next ?? A}"
          tabindex="${this.nextDisabled ? -1 : 0}"
          .disabled=${this.nextDisabled}
          @click=${this.clickNext}
          @keyup=${(evt) => {
      if (evt.key === "Enter" || evt.key === " ") {
        this.clickNext();
      }
    }}
        >
          <jb-icon
            iconName="material:east"
            size="large"
            commonAnimation="move_right"
            ?noHover=${this.nextDisabled}
          ></jb-icon>
        </button>
      </div>
    `;
  }
};
JbArrowNavigation.styles = [reset_css_default, jb_arrow_navigation_css_default];
JbArrowNavigation.shadowRootOptions = { ...i.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n({ type: Object })
], JbArrowNavigation.prototype, "ariaLabels", 2);
__decorateClass([
  n({ type: Boolean })
], JbArrowNavigation.prototype, "nextDisabled", 2);
__decorateClass([
  n({ type: Boolean })
], JbArrowNavigation.prototype, "prevDisabled", 2);
JbArrowNavigation = __decorateClass([
  customElement("jb-arrow-navigation")
], JbArrowNavigation);

export {
  JbArrowNavigation
};
